import { Button } from "@mui/material";
import React, { useState } from "react";
import Dropzone from "react-dropzone";
import clsx from "clsx";
import "../Documents.css";
import { Error } from "@mui/icons-material";
import SubmitButton from "components/Button/SubmitButton";
import CheckIcon from "@mui/icons-material/Check";
import LoadingSpinner from "components/LoadingSpinner";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

const DocumentModal = ({ isModalOpen, onClose, onFileUpload, isLoading }) => {
  const [fileDrag, setFileDrag] = useState(false);
  const [isFileAttached, setIsFileAttached] = useState(false);
  const [isAllowedFileType, setIsAllowedFileType] = useState(true);
  const [file, setFile] = useState();

  const handleDragEnter = () => {
    setFileDrag(true);
  };

  const handleDragLeave = () => {
    setFileDrag(false);
  };

  const dropClasses = clsx("uploadArea mt-2", {
    "uploadArea--hover": fileDrag,
  });

  const handleFiles = (files) => {
    const name = files[0].name;
    const extension = name.split(".").pop().toLowerCase();
    const allowedExtensions = ["pdf", "jpg", "jpeg", "png", "gif"];

    setIsAllowedFileType(true);

    if (!allowedExtensions.includes(extension)) {
      setIsFileAttached(false);
      setIsAllowedFileType(false);
      return;
    }

    setIsFileAttached(true);
    setFile(files[0]);
  };

  return (
    <ModalWrapper
      show={isModalOpen}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      title="Upload Document"
    >
      <div>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <Dropzone
              onDragEnter={handleDragEnter}
              onDragLeave={(e) => handleDragLeave(e)}
              onDrop={(acceptedFiles) => handleFiles(acceptedFiles)}
              disabled={isLoading}
            >
              {({ getRootProps, getInputProps }) => {
                return (
                  <div {...getRootProps()} className={dropClasses}>
                    <div className="uploadContent">
                      <div
                        className={clsx("upload-modal__instruction", {
                          "upload-modal__incorrect-file-type-message":
                            !isAllowedFileType,
                        })}
                      >
                        {!isFileAttached ? (
                          isAllowedFileType ? (
                            <div>
                              Drag a <strong>PDF files</strong> or{" "}
                              <strong>an image</strong> here or select a file
                              from your computer.
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Error style={{ marginRight: "5px" }} />
                              <div>
                                Only <strong>PDF</strong> and{" "}
                                <strong>image</strong> files types allowed.
                              </div>
                            </div>
                          )
                        ) : (
                          <div className="upload-model__file-attached-wrapper">
                            <CheckIcon
                              style={{
                                color: "green",
                                fontSize: 40,
                              }}
                            />
                            <span className="upload-model__file-attached">
                              File Attached:{" "}
                              <span className="upload-model__file-name">
                                {file.name}
                              </span>
                            </span>
                          </div>
                        )}
                      </div>
                      <Button variant="contained">
                        {isFileAttached
                          ? "Change selected file"
                          : "Select file from your computer"}
                      </Button>
                    </div>
                    <input {...getInputProps()} />
                  </div>
                );
              }}
            </Dropzone>
            {isFileAttached && (
              <SubmitButton
                className="mt-2"
                variant="contained"
                color="secondary"
                handleClick={() => onFileUpload(file)}
                fullWidth={true}
                buttonText="Upload Document"
              />
            )}
          </>
        )}
      </div>
    </ModalWrapper>
  );
};

export default DocumentModal;
